import React from 'react'
import { ClimaRegDataType } from '~/api/services/climaProgram'
import BasicFields from './BasicFields'
import ChangesInLastThreeYears from './ChangesInLastThreeYears'
import FeedingPlanSection from './FeedingPlanSection'

interface Props {
  milkOptions: ClimaRegDataType['milkAmounts']
  concentratedFeedsAmounts: ClimaRegDataType['concentratedFeedsAmounts']

}

const FormPart: React.FC<Props> = ({ milkOptions, concentratedFeedsAmounts }) => {
  return (
    <>
      <BasicFields
        milkOptions={milkOptions}
        concentratedFeedsAmounts={concentratedFeedsAmounts}
      />
      <ChangesInLastThreeYears
        milkAmounts={milkOptions}
        concentratedFeedsAmounts={concentratedFeedsAmounts}
      />
      <FeedingPlanSection />
    </>
  )
}

export default FormPart
